import {ClubsConfig, GameData, LeagueTableConfig, Player, Settings, SiteConfig, Sponsor, SponsorsConfig} from '../types';
import {upgradeToHttps} from '../utils/html';

const isObject = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

const asArray = <T>(value: unknown): T[] => (Array.isArray(value) ? value as T[] : []);

function toSponsorsConfig(value: unknown): SponsorsConfig {
    // a plain list of sponsors is accepted as well as {sponsors: [...], interval_seconds, visible}
    const config = (Array.isArray(value) ? {sponsors: value} : isObject(value) ? value : {}) as Partial<SponsorsConfig>;
    const sponsors = asArray<Sponsor>(config.sponsors)
        .filter(sponsor => sponsor?.logo)
        .map(sponsor => ({...sponsor, logo: upgradeToHttps(sponsor.logo)}));
    return {...config, sponsors};
}

/** Turns the raw config posts into a typed config; missing posts fall back to empty values. */
export function toSiteConfig(posts: Record<string, unknown>): SiteConfig {
    return {
        settings: isObject(posts.settings) ? posts.settings as Settings : {},
        tables: asArray<LeagueTableConfig>(posts.tables),
        clubs: isObject(posts.clubs) ? posts.clubs as ClubsConfig : {},
        appointments: asArray<GameData>(posts.appointments),
        players: asArray<Player>(posts.player).map(player => ({...player, picture_url: upgradeToHttps(player.picture_url)})),
        sponsors: toSponsorsConfig(posts.sponsors),
    };
}
